import { useState } from "react";
import { RootState } from "./Account";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { BsArrowRightCircleFill } from "react-icons/bs";
import LinearProgress from "@mui/material/LinearProgress";
import { allcourses } from "../../data/account/allcourse";

const Allcourses = () => {
  const [progress, setProgress] = useState(10);

  const checkTop = useSelector((state: RootState) => state.top.top);
  const allCourses = allcourses.map((course, i) => (
    <div key={i}>
      <img
        src={course.banner}
        width="91"
        height="81"
        alt="course"
      />
      <div>
        <h4>{course.title}</h4>
        {!course.hasStarted && (
          <Link to="/dashboard/videoplayer">
            <p>
              Start Course{" "}
              <BsArrowRightCircleFill
                style={{ verticalAlign: "middle", marginLeft: "5px" }}
              />{" "}
            </p>
          </Link>
        )}
        {course.hasStarted && (
          <div>
            <p
              style={{
                textAlign: "right",
                color: "var(--vidomGray)",
                fontWeight: 400,
                fontSize: "0.75em",
              }}
            >
              10% Complete
            </p>
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{
                height: "2px",
                color: "var(--vidomGray)",
                backgroundColor: "#E1E1E1",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "#0A137C",
                },
              }}
            />
          </div>
        )}
      </div>
    </div>
  ));

  return (
    <section
      className="allcourse-acct"
      style={checkTop}
    >
      {allCourses}
    </section>
  );
};

export default Allcourses;
